import(/* webpackMode: "eager" */ "/codebuild/output/src3398194454/src/base-speak-to-ai/src/app/page.js");
